"use client";

import { View, MobileAuthNotSupportedBanner } from "@/components";

import { GoogleAuthProvider } from "@/features";
import { useAuth, useAuthRedirect } from "@/hooks";
import { useAuthorizeForm } from "../../_hooks";

import {
  AuthorizeSpinner,
  AuthorizeHeroBanner,
  AuthorizePageHeader,
  AuthorizePageContainer,
  AuthorizeIsAuthenticated,
  AuthorizeAuthenticationForm,
  AuthorizeSuccess,
} from "..";
import { Flex } from "@vetty/ui";

/**
 * AuthorizePageView Component
 *
 * Main authorize page with Google OAuth integration and responsive design.
 * Shows different content for authenticated vs guest users.
 */
export const AuthorizePageView = () => {
  useAuthRedirect({ disableRedirect: true });
  const { isAuthenticated, isFetching } = useAuth();
  const { authSuccess, authError } = useAuthorizeForm();

  return (
    <GoogleAuthProvider>
      <View>
        <Flex direction={"column"}>
          <AuthorizePageHeader />

          {/* Spinner */}
          {isFetching && <AuthorizeSpinner />}

          {/* Success message after authorization */}
          {authSuccess && <AuthorizeSuccess />}

          {/* Error message */}
          {authError && !authSuccess && (
            <Flex
              direction={"column"}
              align={"center"}
              style={{ marginTop: "8vh", padding: "0 20px" }}
            >
              <div
                style={{
                  fontSize: "18px",
                  color: "#ef4444",
                  textAlign: "center",
                  background: "#fee2e2",
                  padding: "16px 24px",
                  borderRadius: "8px",
                  border: "1px solid #fecaca",
                }}
              >
                {authError}
              </div>
            </Flex>
          )}

          {/* Authenticated user message */}
          {!isFetching && !authSuccess && isAuthenticated && (
            <AuthorizeIsAuthenticated />
          )}

          {/* Guest user message */}
          {!isFetching && !authSuccess && !isAuthenticated && (
            <AuthorizePageContainer>
              {/* Desktop marketing banner */}
              <AuthorizeHeroBanner />

              {/* Authorize form */}
              <AuthorizeAuthenticationForm />
            </AuthorizePageContainer>
          )}

          {/* Mobile auth not supported banner */}
          <MobileAuthNotSupportedBanner variant="login" />
        </Flex>
      </View>
    </GoogleAuthProvider>
  );
};
